export default __webpack_public_path__ + "static/media/menu-administrator.fb207cc7.svg";